import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { PutFinanceAccountsService } from "@/features/accounts/finance/services/put-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { usePutFinanceAccountStates } from "@/features/accounts/finance/hooks/use-put-accounts-states";
import { useContext } from "react";
import { MoneyLinkError, MoneyLinkException, ErrorLevel } from "@/shared/utils/custom-exception";


export const usePutFinanceAccount = () => {
  const {
    financeAccountId,
    setFinanceAccountId,
    financeId,
    setFinanceId,
    accountSid,
    setAccountSid,
    selectedStatus,
    setSelectedStatus,
    isAggregate,
    setIsAggregate,
    isShowErrorDialog,
    setIsShowErrorDialog,
  } = usePutFinanceAccountStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const putFinanceAccountsService = new PutFinanceAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // 金融機関更新
  const updateFinanceAccounts = async (
    accountGroupId: string,
    financeAccountId: string,
    financeId: string,
    selectedStatus?: number,
    isAggregate?: boolean,
    passbookName?: string,
    useAccountGroupId?: boolean,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await putFinanceAccountsService.putFinanceAccounts({
        account_group_id: accountGroupId,
        finance_account_id: financeAccountId,
        finance_id: financeId,
        ...(selectedStatus !== undefined && { selected_status: selectedStatus }),
        ...(isAggregate !== undefined && { is_aggregate: isAggregate }),
        ...(passbookName !== undefined && { passbook_name: passbookName }),
        ...(useAccountGroupId !== undefined && { use_account_group_id: useAccountGroupId }),
      });
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("updateFinanceAccounts:", error);
      if (
        error instanceof MoneyLinkException &&
        error.error.props.reason === "webmoneylink_parameter_error"
      ) {
        throw new MoneyLinkException({
          error: new MoneyLinkError({
            level: ErrorLevel.Warn,
            code: error.error.props.code,
            reason: error.error.props.reason,
            messageTitle: undefined,
            messageBody:
              "Web明細帳名に使用できない文字が含まれているか、文字数が上限を超えています。\n入力内容をご確認ください。",
          }),
        });
      }
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    financeAccountId,
    setFinanceAccountId,
    financeId,
    setFinanceId,
    accountSid,
    setAccountSid,
    selectedStatus,
    setSelectedStatus,
    isAggregate,
    setIsAggregate,
    isShowErrorDialog,
    setIsShowErrorDialog,
    updateFinanceAccounts: errorHandledAsync(updateFinanceAccounts, setError),
  };
};
